/*
Module Name :      Loader
File Name   :      loader.jsx
Project     :      OrasiMedaia.com
Copyright (c)      peafowl.inc
author      :     Kiran Kumar
author      :
license     :
version     :      0.0.12 // written by  for present.
Created on  :      4th January 2023
Last modified on:  12th January 2023
Description :      
Organisation:      Peafowl inc.
*/

import React, { useState, useEffect } from 'react';
let { appname } = window.app;


const Loader = () => {

    const [img, setImg] = useState(null)
    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    return (

        <>

          <div className="orasi-preloader">
                {/* {img && <img src={`${img}Dadi/Common/images/preloader.png`} />} */}
                <div className="loader"></div>
            </div>

        </>
    );
};


export default Loader;



